import type { Repository } from '../../../types';

export type RepoState =
  | 'connected'
  | 'disconnected'
  | 'connectable'
  | 'unimported';

/**
 * Returns true if the repo has no default branch or branch list, meaning
 * there is nothing meaningful to import or display.
 */
export function isEmptyRepo(repo: Repository): boolean {
  return !repo.branch || !(repo.branches?.length);
}

/**
 * Classify a repository's relationship to the active GitHub App installation.
 * Note: pre-hybrid imports can leave a repo both connected (QI) and connectable
 * (CLI) for the same locator, so "disconnected" specifically requires
 * connectable && !connected on a `github-app` project.
 */
export function classifyRepo(repo: Repository): RepoState {
  const isConnected = !!repo.connectedProjects?.length;
  const isConnectable = !!repo.connectableProjects?.length;
  const isUtilizingGitHubApp = repo.project?.vcs_host === 'github-app';

  if (isConnectable && !isConnected && isUtilizingGitHubApp) {
    return 'disconnected';
  }

  if (repo.project || isConnected) {
    return 'connected';
  }

  if (isConnectable) {
    return 'connectable';
  }

  return 'unimported';
}
